import PropTypes from 'prop-types';
import Link from '@/components/Link';
import FeaturedImage from '@/shapes/FeaturedImage';
import TrainerProfilePicture from './TrainerProfilePicture';
import TrainerListingName from './TrainerListingName';
import TrainerListingCity from './TrainerListingCity';
import TrainerListingCard from './TrainerListingCard';
import TrainerListingActions from './TrainerListingActions';

const defaultProps = {};

const propTypes = {
  name: PropTypes.string.isRequired,
  featuredImage: FeaturedImage,
};

export default function TrainerListing({
  name,
  uri,
  featuredImage: { node: profilePicture },
  info: { city },
  social,
}) {
  const hasCity = city !== null;

  return (
    <TrainerListingCard>
      <div className="flex-1 flex flex-col items-center text-center space-y-4 lg:space-y-6 rounded-lg lg:rounded-xl xl:rounded-2xl overflow-hidden">
        <Link
          href={uri}
          className="relative w-full flex items-center justify-center pt-6 lg:pt-10 xl:pt-14"
        >
          <div className="relative z-10">
            <TrainerProfilePicture name={name} picture={profilePicture} />
          </div>
          <div className="absolute w-full top-0 left-0 right-0 bg-green-500 bg-gradient-to-b from-green-600 to-green-500 h-40 z-0 overflow-hidden -mt-10 transform -skew-y-6">
            <div className="absolute inset-0 w-full pointer-events-none overflow-hidden opacity-25">
              <div className="w-full h-10 bg-green-100 bg-gradient-to-r from-green-600 to-transparent" />
              <div className="w-full h-10 bg-green-200 bg-gradient-to-r from-green-500 to-transparent" />
              <div className="w-full h-8 bg-green-300 bg-gradient-to-l from-green-600 to-transparent" />
            </div>
          </div>
        </Link>
        <div className="pb-4 lg:pb-10 xl:pb-14 space-y-px">
          <TrainerListingName fullName={name} uri={uri} />
          {hasCity && <TrainerListingCity city={city} />}
        </div>
      </div>
      <TrainerListingActions uri={uri} social={social} />
    </TrainerListingCard>
  );
}

TrainerListing.defaultProps = defaultProps;
TrainerListing.propTypes = propTypes;
